import { AfterViewInit, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { Master } from '../../../../../services/master';
import { P } from '@angular/cdk/keycodes';
import { Auth } from '../../../../../services/auth';
import { Router } from '@angular/router';
import { QuestionState } from '../../../../../services/question-state';

@Component({
  selector: 'app-trade-gpt',
  standalone: false,
  templateUrl: './trade-gpt.html',
  styleUrl: './trade-gpt.less'
})
export class TradeGpt implements OnInit,AfterViewInit{
  private masterService = inject(Master);
  private questionState = inject(QuestionState);
  inputField:any;
  chatHistory: { question: any, answer: any }[] = [];
  historyList: { question: any, answer: any }[] = [];
  showHistory: boolean = false;
  hasNotifications: boolean = true;

  toggleHistory() {
    this.showHistory = !this.showHistory;
  }
  loading: boolean = false;
  user: any;
  chat: any;
  rowNum: any = 0;
  size: any = 10;
  tradeHistory: any[] = [];
  private authService = inject(Auth);
  private router = inject(Router);
  @ViewChild('targetInput') targetInput!: ElementRef<HTMLInputElement>;
  @ViewChild('chatContainer') private chatContainer!: ElementRef;
  @ViewChild('messagesList') private messagesList!: ElementRef;
  private shouldScroll = false;
  constructor() {
    this.authService.user.subscribe((x: any) => this.user = x)
  }

  ngOnInit(): void {
    this.chat = null;
    this.chatHistory = []; // Ensure landing page is shown on load
    this.questionState.currentQuestion$.subscribe((q: any) => {
      this.chat = q;
      this.scrollToQuestion();
    });
    this.getTradeGPTHistory(this.rowNum, this.size);
  }

  scrollToQuestion() {
    setTimeout(() => {
      if (this.messagesList) {
        this.messagesList.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 50);
  }

  ngAfterViewInit(): void {
    if (this.shouldScroll) {
      this.scrollToBottom();
    }
    if (this.targetInput) {
      this.targetInput.nativeElement.focus({ preventScroll: true });
    }
  }

  search() {
    this.loading = true;
    this.chat = null; // Clear single chat view when starting a new search
    const chatItem = { question: this.inputField, answer: '' }
    this.chatHistory.push(chatItem);
    this.inputField = '';
    this.shouldScroll = true;
    this.masterService.letsTalkTradeSecure(chatItem.question, this.user.orgId, this.user.mobilePhone)
      .subscribe({
        next: (data: any) => {
          chatItem.answer = data.answer;
          this.getTradeGPTHistory(this.rowNum, this.size);
          this.loading = false;
          this.inputField = '';
        }, error: (error: any) => {
          console.log(error);
          this.loading = false;
        }
      })
  }

  getTradeGPTHistory(rowNum: any, size: any) {
    this.masterService.getTradeGPTHistory(rowNum, size).
      subscribe({
        next: (data: any) => {
          this.tradeHistory = data.rows;
          this.generateHistoryRecord(this.tradeHistory);
        }
      })
  }

  generateHistoryRecord(tradeHistory: any) {
    this.historyList = []; // Populate separate history list for sidebar
    for (let i = 0; i < tradeHistory.length; i += 2) {
      this.historyList.push({
        answer: tradeHistory[i].chat || null,
        question: tradeHistory[i + 1].chat || null
      })
    }
    this.questionState.setChatHistory(this.historyList);
  }

  selectHistoryItem(item: any) {
    this.chat = item;
    this.chatHistory = []; // Clear current session view when selecting history
    this.toggleHistory();
  }


  scrollToBottom(){
    if(this.chatContainer){
      const element = this.chatContainer.nativeElement;
      element.scrollTop= element.scrollHeight;
      this.shouldScroll = false;
    }
  }

  copyQuestion(question:any){
    navigator.clipboard.writeText(question).then(()=>{

    })
  }
  pause(){

  }

  isInRole(privileges:string[]){
    const cc = this.user?.privileges?.filter((x:any) => privileges.includes(x));
    if(cc != undefined && cc?.length > 0){
        return true;
    }else{
        return false;
    }
    
}

  moveToBrowse(){
    if(this.isInRole(['IS_SELLER_ADMIN'])){
      this.router.navigate(['seller-catalog']);
    }else if(this.isInRole(['IS_BUYER','IS_BUYER_ADMIN'])){
      this.router.navigate(['catalog']);
    }

  }
   

  startQuickSearch(query: string) {
    this.inputField = query;
    this.search();
  }

  formatAnswer(text: string): string {
    if (!text) return '';
    let html = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    
    const lines = html.split('\n');
    let inList = false;
    let formattedLines = [];
    
    for (let i = 0; i < lines.length; i++) {
      let line = lines[i].trim();
      
      if (line.startsWith('- ') || line.startsWith('* ')) {
        if (!inList) {
          formattedLines.push('<ul class="mb-3" style="padding-left: 1.5rem;">');
          inList = true;
        }
        // Remove the bullet and trim
        let bulletText = line.substring(2).trim();
        formattedLines.push(`<li class="mb-2">${bulletText}</li>`);
      } else {
        if (inList) {
          formattedLines.push('</ul>');
          inList = false;
        }
        
        if (line !== '') {
          if (line.startsWith('### ')) {
            formattedLines.push(`<h6 class="fw-bold mt-4 mb-2 text-dark">${line.substring(4)}</h6>`);
          } else if (line.startsWith('## ')) {
            formattedLines.push(`<h5 class="fw-bold mt-4 mb-2 text-dark">${line.substring(3)}</h5>`);
          } else if (line.startsWith('# ')) {
            formattedLines.push(`<h4 class="fw-bold mt-4 mb-2 text-dark">${line.substring(2)}</h4>`);
          } else {
            formattedLines.push(`<p class="mb-3">${line}</p>`);
          }
        }
      }
    }
    
    // Close any unclosed list
    if (inList) {
      formattedLines.push('</ul>');
    }
    
    return formattedLines.join('\n');
  }
}
